<!--Start rev slider wrapper-->  
<br> 
<br> 
<br>


<section class="rev_slider_wrapper">
    <div id="slider1" class="rev_slider"  data-version="5.0" >
        
        <ul>
            <li data-transition="fade">
                <img src="assets/images/slides/crochet5.jpg"  alt="" width="1920" height="500" data-bgposition="top center" data-bgfit="cover" data-bgrepeat="no-repeat" data-bgparallax="1">
                
                <div class="tp-caption  tp-resizeme" 
                    data-x="left" data-hoffset="0" 
                    data-y="top" data-voffset="370" 
                    data-transform_idle="o:1;"         
                    data-transform_in="x:[-175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0.01;s:3000;e:Power3.easeOut;" 
                    data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;" 
                    data-mask_in="x:[100%];y:0;s:inherit;e:inherit;" 
                    data-splitin="none" 
                    data-splitout="none"
                    data-responsive_offset="on"
                    data-start="700">
                    
                    <div class="slide-content left-slide">
                        <div class="title">Handmade with love, stitched with passion</div>
                        <div class="big-title">SKYBETH </div>
                        <div class="text">Crochet creates comfort and style.</div>
                        <div class="btns-box">
                          
                            <a href="shop" class="thm-btn btn-style-two pdtwo">Shop</a> 
                        </div>
                    </div>
                </div>
            </li>
           <!-- <li data-transition="fade">
                <img src="assets/images/resources/banner2.jpg" alt="" width="1920" height="500" data-bgposition="top center" data-bgfit="cover" data-bgrepeat="no-repeat" data-bgparallax="1" >
                
               <div class="tp-caption  tp-resizeme" 
                    data-x="right" data-hoffset="0" 
                    data-y="top" data-voffset="370" 
                    data-transform_idle="o:1;"         
                    data-transform_in="x:[-175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0.01;s:3000;e:Power3.easeOut;" 
                    data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;" 
                    data-mask_in="x:[100%];y:0;s:inherit;e:inherit;" 
                    data-splitin="none" 
                    data-splitout="none"
                    data-responsive_offset="on"
                    data-start="1500">
                    
                    <div class="slide-content right-slide">
                         <div class="title">Handmade with love, stitched with passion</div>
                        <div class="big-title">SKYBETH </div>
                        <div class="text">Crochet creates comfort and style.</div>
                        <div class="btns-box">
                            <a href="shop" class="thm-btn btn-style-two pdtwo">Shop</a> 
                        </div>
                    </div>
                </div>
            </li>-->
         
        </ul>
    </div>
</section>


<div class="video-galley-content parallax-bg-one" style="background-image:url(assets/images/resources/homecenter.jpg);height: 80px;">
   <div class="container">
       <div class="row">
           <div class="col-md-12">
               <div class="inner-content text-center">
                   <div class="title"><h1>Welcome Skybeth Store</h1></div>
                 
                   <div class="icon-holder">
                     
                   </div>
               
               </div>
           </div>
       </div>
   </div>   
</div>

<section class="latest-project-area">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="sec-title">
                    <span>Our Cases</span>
                    <div class="border"></div> 
                    <h1>Welcome to Skybeth!</h1>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12">
                <div class="left-content" >
                    <h3></h3>
                    <p>Handmade with love and stitched with passion, <b>Skybeth</b> is your cozy destination for premium, high-quality crochet creations. We are dedicated to bringing both comfort and style into your everyday life through our meticulously crafted designs.
Whether you are looking for an irresistibly soft plushie companion to brighten your space or a stylish, textured accessory to elevate your daily routine, every single piece in our shop is woven with care and designed to bring a smile to your face.
Explore our collections and find the perfect handmade treasure to add a touch of cozy magic to your world!
</p>
                 
                </div>
            </div>
            <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12" style="padding-top: 10px;">
                <div class="right-content">
                    <div class="projects-carousel owl-nav-style-one">
                      
                        <div class="single-project-item">
                            <div class="img-holder">
                                <img src="assets/images/projects/tt2.png" height="300" alt="Awesome Image">
                                <div class="static-overlay" style="text-align: center">
                                    <h3 ><a href="#">Mini Elephant</a></h3>
                                    
                                </div>
                                <div class="overlay"  style="background: black">
                                    <div class="content">
                                        <h3 style="color: orange">Mini Elephant</h3>
                                       
                                        <h6 style="color: #fff">Meet Your New Best Friend: The Blue Crochet Elephant Plushie. Bring a touch of handmade magic into your home with this absolutely adorable Mini Blue Crochet Elephant. Perfectly palm-sized and bursting with personality, this little elephant is ready to stomp its way straight into your heart! Crafted with love, its vibrant blue hue and detailed stitching make it a standout addition to any nursery, work desk, or plushie collection.  </h6>
                                        <a class="readmore" href="/about">Read More<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                    <a class="btn warning" href="/shop" >Shop</a> 
                                </div>
                                
                            </div>  
                            
                        </div> 
                      
                        <div class="single-project-item">
                            <div class="img-holder">
                                <img src="assets/images/projects/tt1.png"  height="310" alt="Awesome Image">
                                <div class="static-overlay">
                                    <h3 style="text-align: center"><a href="#">Puppy</a></h3>
                                    
                                </div>
                                <div class="overlay" style="background: black">
                                    <div class="content">
                                        <h3 style="color: orange">Puppy</h3>
                                        
                                        <h6 style="color: #fff">Meet Your New Best Friend: The Handmade Crochet Puppy Plushie! Bring home the ultimate bundle of joy with this absolutely adorable, handmade crochet puppy plushie. Perfectly sized for cuddles, desk company, or a sweet nursery accent, this little pup is ready to steal your heart! ✨ Product Highlights * Premium Softness: Crafted using 100% premium polyester yarn, giving it an incredibly velvety, cloud-like texture that feels amazing to the touch. </h6>
                                        <a class="readmore" href="/about">Read More<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                    <a class="btn warning" href="/shop" >Shop</a> 
                                </div>
                            </div>   
                        </div> 
                       
                        <div class="single-project-item">
                            <div class="img-holder">
                                <img src="assets/images/projects/tt4.png"  height="300" alt="Awesome Image">
                                <div class="static-overlay">
                                    <h3 style="text-align: center"><a href="#">Crochet Loaf Cat</a></h3>
                                   
                                </div>
                                <div class="overlay" style="background: black">
                                    <div class="content">
                                        <h3 style="color: orange">Crochet Loaf Cat</h3>
                                      
                                        <h6 style="color: #fff">Meet Your New Best Friend: The Crochet Loaf Cat Plushie Bring a touch of handmade magic into your home with this absolutely adorable Crochet Loaf Cat. Perfectly palm-sized and bursting with personality, this little kitty is ready to curl up straight into your heart! Crafted with love, its detailed stitching and charming, loaf-like shape make it a standout addition to any nursery, work desk, or plushie collection.</h6>
                                        <a class="readmore" href="/about">Read More<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                    
                                    <a class="btn warning" href="/shop" >Shop</a> 
                                </div>
                            </div>   
                        </div> 
                          <div class="single-project-item">
                            <div class="img-holder">
                                <img src="assets/images/projects/tt5.png"  height="300" alt="Awesome Image">
                                <div class="static-overlay">
                                    <h3 style="text-align: center"><a href="#">Kittent</a></h3>
                                   
                                </div>
                                <div class="overlay" style="background: black">
                                    <div class="content">
                                        <h3 style="color: orange">Kitten</h3>
                                      
                                        <h6 style="color: #fff">Meet Your New Best Friend: The Crochet Kitten Plushie Bring a touch of handmade magic into your home with this absolutely adorable Mini Crochet Kitten. Perfectly palm-sized and bursting with personality, this little kitty is ready to curl up straight into your heart! Crafted with love, its detailed stitching and charming features make it a standout addition to any nursery, work desk, or plushie collection. </h6>
                                        <a class="readmore" href="/about">Read More<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                    
                                    <a class="btn warning" href="/shop" >Shop</a> 
                                </div>
                            </div>   
                        </div> 
                    </div>           
                </div> 
            </div>
        </div>
    </div>
</section> 

 <section class="video-gallery-area">
   
    <div class="video-galley-content parallax-bg-one" style="background-image:url(assets/images/resources/banner1.jpg);">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="inner-content text-center">
                        <div class="title"><h1>We are trusted by our customers</h1></div>
                        <div class="text"><p>At <b>Skybeth</b>, every stitch matters. We are incredibly grateful to our wonderful customers who value the care, time, and premium quality that goes into each of our handmade creations.</p></div> 
                        <div class="icon-holder">
                           <a class="btn warning" href="/shop">Check our Products</a>
                          
                        </div>
                     
                    </div>
                </div>
            </div>
        </div>   
    </div>
</section>
<div class="container">
<div class="carousel">
    <div class="group" *ngFor="let testimony of testimonies">
        <div class="card ">
            <div style="padding-bottom: 10px;">
            <span *ngFor="let star of [1,2,3,4,5]">
              <i class="fa"
                 [ngClass]="star <= testimony.star ? 'fa-star text-warning' : 'fa-star-o text-secondary'">
              </i>
            </span>
          </div>
          <h4 class="comment" style="padding: 0 0 0 10">{{ testimony.comment }}</h4>
        <h5 style="padding-bottom: 5px;">{{ testimony.fullName }}</h5
            >
          
          </div>
    </div>
   
</div>

</div>


 